import React, { useState, useEffect } from 'react';

/**
 * A utility component that renders its children only on the client-side after mounting.
 * This is crucial for preventing non-essential, interactive components (like chat widgets)
 * from being part of the server-side render, which improves performance and reliability
 * for SEO crawlers and prerendering services.
 */
const ClientOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return <>{children}</>;
};

export default ClientOnly;